import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAppContext } from '../../../AppModulesWrapper';
import { selectMicrofrontendHostName } from '../../../Microfrontend';

import { getTelemetryKey } from './utils';

export const useTelemetry = () => {
  const { telemetry, isMicrofrontend } = useAppContext();

  const microfrontendHostName = useSelector(selectMicrofrontendHostName);
  const hostKey = (isMicrofrontend ? microfrontendHostName : 'nativeApp')!;

  const increment = useCallback((key: string) => {
    const telemetryKey = getTelemetryKey({ hostKey, valueKey: key });

    telemetry.increment(telemetryKey);
  }, []);

  const incrementLoadPagePerfomanceTimer = useCallback((key: string, time: number) => {
    const telemetryKey = getTelemetryKey({ hostKey, valueKey: key });

    telemetry.timer(telemetryKey, time);
  }, []);

  return { increment, incrementLoadPagePerfomanceTimer };
};
